import brands from '../config/brands.json';

import HelperGenerics from './HelperGenerics'

class HelperVehicle {

	static isEnoughForCalculation(vehicle) {
		if (vehicle != null && vehicle.pricing != null && ((vehicle.pricing.netPriceInclTax != null && vehicle.pricing.netPriceInclTax > 6000.0)
			|| (vehicle.pricing.netPriceExclTax != null && vehicle.pricing.netPriceExclTax > 6000.0))) {
			return true;
		}
		return false;
	}
	static isEnoughForCalculationMultiple(vehicles) {
		for (const vehicleKey in vehicles) {
			if (!HelperVehicle.isEnoughForCalculation(vehicles[vehicleKey])) {
				return false;
			}
		}
		return true;
	}

	static getVehicleResourceConfigKey(vehicleIni, vehDescType) {
		if (vehDescType === 'MANUFACTURER') {
			return {
				...vehicleIni, brand: undefined,
				presentation: HelperVehicle.getVehiclePresentationResource(vehicleIni),
				features: HelperVehicle.getVehicleFeatures(vehicleIni, vehDescType),
				fiscalProperties: HelperVehicle.getVehicleFiscalProperties(vehicleIni, vehDescType),
				state: HelperVehicle.getVehicleStateResource(vehicleIni, vehDescType),
				...HelperVehicle.getManufacturerCode(vehicleIni, true),
				noAdditionalDiscountToApply: vehicleIni.noAdditionalDiscountToApply ? vehicleIni.noAdditionalDiscountToApply : undefined,
			};
		}
		return {
			...vehicleIni,
			presentation: HelperVehicle.getVehiclePresentationResource(vehicleIni),
			features: HelperVehicle.getVehicleFeatures(vehicleIni, vehDescType),
			fiscalProperties: HelperVehicle.getVehicleFiscalProperties(vehicleIni, vehDescType),
			pricing: vehicleIni.pricing,
			rvAdjustment: HelperVehicle.getVehicleRvAdjustment(vehicleIni),
			...HelperVehicle.getManufacturerCode(vehicleIni, false), options: undefined, accessories: undefined,
		};
	}

	static buidVehicleConfigurationKey(i) {
		return `veh_${(i * 1.0 + 1)}`;
	}

	static getVehicleWidget(vehicleIni, vehDescType) {
		if (vehDescType === 'MANUFACTURER') {
			return {
				...vehicleIni, brand: undefined,
				presentation: HelperVehicle.getVehiclePresentationWidget(vehicleIni.presentation),
				features: HelperVehicle.getVehicleFeatures(vehicleIni, vehDescType),
				fiscalProperties: HelperVehicle.getVehicleFiscalProperties(vehicleIni, vehDescType),
				state: HelperVehicle.getVehicleStateResource(vehicleIni, vehDescType),
				...HelperVehicle.getManufacturerCode(vehicleIni, true),
				noAdditionalDiscountToApply: vehicleIni.noAdditionalDiscountToApply ? vehicleIni.noAdditionalDiscountToApply : undefined,
			};
		}
		return {
			...vehicleIni,
			presentation: HelperVehicle.getVehiclePresentationWidget(vehicleIni.presentation),
			features: HelperVehicle.getVehicleFeatures(vehicleIni, vehDescType),
			fiscalProperties: HelperVehicle.getVehicleFiscalProperties(vehicleIni, vehDescType),
			pricing: vehicleIni.pricing,
			rvAdjustment: HelperVehicle.getVehicleRvAdjustment(vehicleIni),
			...HelperVehicle.getManufacturerCode(vehicleIni, false), options: undefined, accessories: undefined,
		};
	}
	static getVehicleResourceMultiMTO(vehicleIni, vehDescType) {
		if (vehDescType === 'MANUFACTURER') {
			return {
				...vehicleIni,
				options: undefined, accessories: undefined, brand: undefined,
				configurationKey: undefined,
				presentation: HelperVehicle.getVehiclePresentationResource(vehicleIni),
				features: HelperVehicle.getVehicleFeatures(vehicleIni, vehDescType),
				fiscalProperties: HelperVehicle.getVehicleFiscalProperties(vehicleIni, vehDescType),
				state: HelperVehicle.getVehicleStateResource(vehicleIni, vehDescType),
				...HelperVehicle.getManufacturerCode(vehicleIni, true),
				noAdditionalDiscountToApply: vehicleIni.noAdditionalDiscountToApply ? vehicleIni.noAdditionalDiscountToApply : undefined,
			};
		}
		return undefined;
	}
	static getVehicleResourceSingle(vehicleIni, vehDescType) {
		return { ...HelperVehicle.getVehicleResourceConfigKey(vehicleIni, vehDescType), configurationKey: undefined };
	}

	static getManufacturerCode(vehicleIni, isWithValue) {
		if (isWithValue) {
			return {
				lcdv16Code: HelperGenerics.isNotNullAndNotEmpty(vehicleIni.lcdv16Code) ? vehicleIni.lcdv16Code : undefined,
				manufacturerCode: HelperGenerics.isNotNullAndNotEmpty(vehicleIni.manufacturerCode) ? vehicleIni.manufacturerCode : undefined,
				manufacturerCodeType: HelperGenerics.isNotNullAndNotEmpty(vehicleIni.manufacturerCode) ? vehicleIni.manufacturerCodeType : undefined,
				blvdCode: HelperGenerics.isNotNullAndNotEmpty(vehicleIni.blvdCode) ? vehicleIni.blvdCode : undefined,
				optionsEncoding: HelperGenerics.isNotNullAndNotEmpty(vehicleIni.optionsEncoding) ? vehicleIni.optionsEncoding : undefined
			}
		}
		return {
			lcdv16Code: undefined, manufacturerCode: HelperGenerics.isNotNullAndNotEmpty(vehicleIni.manufacturerCode) ? vehicleIni.manufacturerCode : undefined,
			manufacturerCodeType: HelperGenerics.isNotNullAndNotEmpty(vehicleIni.manufacturerCode) ? vehicleIni.manufacturerCodeType : undefined, blvdCode: undefined, optionsEncoding: undefined
		};
	}

	static getVehiclePresentationResource(vehicleIni) {
		if (vehicleIni.presentation) {
			return {
				longLabel: vehicleIni.presentation.longLabel && vehicleIni.presentation.longLabel.length > 0 ? vehicleIni.presentation.longLabel : undefined,
				longLabelBase64: vehicleIni.presentation.longLabelBase64 && vehicleIni.presentation.longLabelBase64.trim().length > 0 ? vehicleIni.presentation.longLabelBase64 : undefined
			};
		}
		return undefined;
	}
	static getVehiclePresentationWidget(vehiclePresentationIni) {
		if (!vehiclePresentationIni) {
			return null;
		}
		return {
			...vehiclePresentationIni,
			longLabel: vehiclePresentationIni.longLabel && vehiclePresentationIni.longLabel.length > 0 ? vehiclePresentationIni.longLabel : undefined,
			longLabelBase64: vehiclePresentationIni.longLabelBase64 && vehiclePresentationIni.longLabelBase64.trim().length > 0 ? vehiclePresentationIni.longLabelBase64 : undefined
		}
	}
	static getVehicleStateResource(vehicleIni, vehDescType) {
		if (vehicleIni != null && vehicleIni.state != null) {
			if (vehDescType === "MANUFACTURER" && vehicleIni.state.stateType == null) {
				vehicleIni.state.stateType = "VN";
			}
			return vehicleIni.state;
		}
		return undefined;
	}
	static getVehicleFeatures(vehicleIni, vehDescType) {
		if (vehicleIni != null && vehicleIni.features != null) {
			if (vehDescType === 'ANYBRAND') {
				return {
					kind: vehicleIni.features.kind, energyUsed: vehicleIni.features.energyUsed,
					maximumPowerHP: vehicleIni.features.maximumPowerHP, maximumPowerKW: vehicleIni.features.maximumPowerKW,
					maximumPowers: vehicleIni.features.maximumPowers
				};
			}
			return { ...vehicleIni.features, energy: vehicleIni.features.energy };
		}
		return undefined;
	}
	static getVehicleRvAdjustment(vehicleIni) {
		if (vehicleIni != null && vehicleIni.rvAdjustment != null) {

			return { increasePercent: vehicleIni.rvAdjustment.increasePercent, balloonAmountOverride: vehicleIni.rvAdjustment.balloonAmountOverride };
		}
		return undefined;
	}
	static getVehicleFiscalProperties(vehicleIni, vehDescType) {
		if (vehicleIni != null && vehicleIni.fiscalProperties != null) {
			if (vehDescType === 'ANYBRAND') {
				return {
					co2Emissions: vehicleIni.fiscalProperties.co2Emissions, wltpCo2Emissions: vehicleIni.fiscalProperties.wltpCo2Emissions,
					fiscalHorsePower: vehicleIni.fiscalProperties.fiscalHorsePower
				};
			}
			return { ...vehicleIni.fiscalProperties };
		}
		return undefined;
	}
	static getOffersVehicleFeatures(vehicleIni, vehDescType) {
		if (vehicleIni.features != null) {
			if (vehDescType === 'ANYBRAND') {
				return {
					kind: vehicleIni.features.kind, energyUsed: vehicleIni.features.energyUsed,
					maximumPowerHP: vehicleIni.features.maximumPowerHP, maximumPowerKW: vehicleIni.features.maximumPowerKW,
					maximumPowers: vehicleIni.features.maximumPowers
				};
			}
			return { kind: vehicleIni.features.kind, energy: vehicleIni.features.energy };
		}
		return undefined;
	}

	static getOffersVehicleOptions(vehicleIni, vehDescType) {
		if (vehicleIni.options != null && vehDescType === 'MANUFACTURER') {
			var newOptions = [];
			for (var i in vehicleIni.options) {
				newOptions.push({ code: vehicleIni.options[i].code });
			}
			return newOptions;
		}
		return undefined;
	}

	static getBrandsList() {
		return brands;
	}
	
	static getManufacturerCodeTypeList() {
		return ['LCDV', 'BMVSS', 'MASERATI', 'CPOS', 'JLR'];
	}
}

export default HelperVehicle

